import { ApplicationConfig, APP_INITIALIZER, provideBrowserGlobalErrorListeners, provideZonelessChangeDetection } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter } from '@angular/router';


import { routes } from './app.routes';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';

import { providePrimeNG } from 'primeng/config';
import { ConfirmationService, MessageService } from 'primeng/api';
import Aura from '@primeuix/themes/aura';

import { provideIcons } from '@ng-icons/core';
import * as heroIconsOutline from '@ng-icons/heroicons/outline';
import * as heroIconsSolid from '@ng-icons/heroicons/solid';
import * as phosphorRegular from '@ng-icons/phosphor-icons/regular';
import * as phosphorFill from '@ng-icons/phosphor-icons/fill';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { requestHeaderInterceptor } from './core/services/http/request-header-interceptor';
import { verifySessionFactory } from './core/validators/session.validator';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getMessaging, provideMessaging } from '@angular/fire/messaging';
import { environment } from '../environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          prefix: 'p',
          darkModeSelector: false || 'none',
          cssLayer: false
        }
      }
    }),
    provideAnimationsAsync(),
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes), provideClientHydration(withEventReplay()),
    provideIcons(phosphorRegular),
    provideIcons(phosphorFill),
    provideIcons(heroIconsOutline),
    provideIcons(heroIconsSolid),
    MessageService,
    ConfirmationService,
    provideHttpClient(withFetch(), withInterceptors([requestHeaderInterceptor]))
    ,
    {
      provide: APP_INITIALIZER,
      multi: true,
      useFactory: verifySessionFactory
    }, provideFirebaseApp(() => initializeApp(environment.firebaseConfig)), provideMessaging(() => getMessaging())
  ]
};
